// assets/a24-redirects.js
(function () {
  'use strict';

  function initRedirects(scope) {
    if (window.A24Theme?.shouldProtectEditorClicks?.()) return;

    // Führt Liquid-definierte Redirect-Ziele ohne Inline-JavaScript aus.
    var root = scope || document;
    if (root.matches && root.matches('[data-a24-redirect]')) {
      redirect(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-a24-redirect]').forEach(redirect);
    }
  }

  function redirect(node) {
    // Pro Redirect-Element nur einmal navigieren.
    if (!node || node.dataset.a24RedirectReady === 'true') return;
    node.dataset.a24RedirectReady = 'true';

    var url = String(node.getAttribute('data-a24-redirect-url') || '').trim();
    if (!url) return;
    window.location.replace(url);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initRedirects(document); }, { once: true });
  } else {
    initRedirects(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRedirects(event.target);
  });
})();
